import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Category} from "../../models/category";

import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {User} from "../../models";

@Component({
    selector: 'customer-form-dialog',
    templateUrl: './customerDialog.component.html',
    styleUrls: ['./customerDialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class CustomerDialogComponent {
    action: string;
    customer: User;
    customerForm: FormGroup;
    dialogTitle: string;

    /**
     * Constructor
     *
     * @param {MatDialogRef<CustomerDialogComponent>} matDialogRef
     * @param _data
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        public matDialogRef: MatDialogRef<CustomerDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService
    ) {
        this.translationLoader.loadTranslations(polish);
        // Set the defaults
        this.action = _data.action;

        if (this.action === 'edit') {
            translate.get('Edit customer data').subscribe((text: string) => {
                this.dialogTitle = text
            });

            this.customer = _data.customer;
        } else {
            translate.get('New customer').subscribe((text: string) => {
                this.dialogTitle = text
            });
            this.customer = new User();
        }

        this.customerForm = this.createCustomerForm();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Create customer form
     *
     * @returns {FormGroup}
     */
    createCustomerForm(): FormGroup {
        return this._formBuilder.group({
            id: [this.customer.id],
            firstName: [this.customer.firstName],
            lastName: [this.customer.lastName],
            phone: [this.customer.phone],
            email: [this.customer.email],
        });
    }
}
